var x = /* @__PURE__ */ ((r) => (r.PlainText = "PlainText", r.RichText = "RichText", r.FontRenderer = "FontRenderer", r.Markdown = "Markdown", r.DropdownList = "DropdownList", r.LongText = "LongText", r))(x || {});
export {
  x as StringFieldComponentEnum
};
